import { APICore } from "./apiCore";

const api = new APICore();

export interface ModeloProntuarioEspecialidade {
  id: number;
  descricao: string;
}

export interface ModeloProntuario {
  id: number;
  licenca_id: number;
  texto: string;
  padrao: boolean;
  especialidades: ModeloProntuarioEspecialidade[];
}

export interface ModeloProntuarioPayload {
  texto: string;
  padrao: boolean;
  especialidade_ids: number[];
}

const listarModelosProntuario = () => {
  return api.get("/modelo-prontuario");
};

const obterModeloProntuario = (id: string | number) => {
  return api.get(`/modelo-prontuario/${id}`);
};

/** Modelo aplicável a uma especialidade: o do grupo ou, se não houver, o padrão. */
const resolverModeloProntuario = (especialidade_id?: number | null) => {
  return api.get("/modelo-prontuario/resolve", {
    especialidade_id: especialidade_id ?? undefined,
  });
};

const criarModeloProntuario = (params: ModeloProntuarioPayload) => {
  return api.create("/modelo-prontuario", params);
};

const atualizarModeloProntuario = (
  id: string | number,
  params: ModeloProntuarioPayload
) => {
  return api.update(`/modelo-prontuario/${id}`, params);
};

const excluirModeloProntuario = (id: string | number) => {
  return api.delete(`/modelo-prontuario/${id}`);
};

export {
  listarModelosProntuario,
  obterModeloProntuario,
  resolverModeloProntuario,
  criarModeloProntuario,
  atualizarModeloProntuario,
  excluirModeloProntuario,
};
